import React, { useEffect, useState } from "react";
import "../../../css/pages/ca_pages/models/ClientSearchDropdown.css";

const SearchDropdown = ({
    searchFunction,
    onSelect,
    onClear,
    placeholder = "Search...",

    getText = (item) => item?.name || "",
    getSubText = null,
    getKey = (item) => item?.id,
    getSelectedValue = (item) => item?.name || item?.email || "",
}) => {
    const [results, setResults] = useState([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const trimmedSearch = (search || "").trim();

        if (!trimmedSearch) {
            setResults([]);
            setLoading(false);
            return;
        }

        const delay = setTimeout(async () => {
            try {
                setLoading(true);

                const response = await searchFunction(trimmedSearch);

                setResults(response?.data || []);
            } catch (error) {
                console.error("Search failed:", error);
                setResults([]);
            } finally { setLoading(false); }
        }, 300);

        return () => clearTimeout(delay);
    }, [search, searchFunction]);

    const handleSelect = (item) => {
        onSelect(item);

        const selectedValue = getSelectedValue(item) || "";

        setSearch(selectedValue);
        setOpen(false);
    };

    const handleInputChange = (e) => {
        const value = e.target.value;

        setSearch(value);
        setOpen(true);

        // If the user changes the selected value,
        // clear the parent's selected item.
        if (onClear) { onClear(); }
    };

    return (
        <div className = "dropdown-wrapper">
            <input
                type        = "text"
                placeholder = { placeholder }
                value       = { search }
                onChange    = { handleInputChange }
                onFocus     = { () => { if ((search || "").trim()) { setOpen(true); } }}
            />

            {open && (search || "").trim() && (
                <div className = "dropdown-box">
                    {loading ? (
                        <div className="dropdown-item">
                            Searching...
                        </div>
                    ) : results.length > 0 ? (
                        results.map((item, idx) => {
                            const text = getText(item);
                            const subText = getSubText ? getSubText(item) : null;

                            return (
                                <button
                                    type      = "button"
                                    key       = { getKey(item) ?? idx }
                                    className = "dropdown-item"
                                    onClick   = { () => handleSelect(item) }
                                >
                                    <strong>{text}</strong>

                                    {subText && ( <small>{subText}</small> )}
                                </button>
                            );
                        })
                    ) : (
                        <div className="dropdown-item">
                            No results found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default SearchDropdown;
